import { render, staticRenderFns } from "./CommissionDistributionRuleSetUpdate.vue?vue&type=template&id=40bf4076"
import script from "./CommissionDistributionRuleSetUpdate.vue?vue&type=script&lang=js"
export * from "./CommissionDistributionRuleSetUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports